<div class="wrap">
  <router-outlet></router-outlet>
</div>
